"use client";

import { useMedia } from "~/components/media/Provider";
import { MediaButton } from "./Buttons";

export function DiySketches() {
	const { sections, onMediaChange } = useMedia();

	const section = sections.find((section) => section.id === "drawings");

	if (!section) return null;

	return (
		<MediaButton
			title={section.title}
			icon={section.icon}
			count={section.items.length}
			onClick={() => onMediaChange({ type: "detail", id: section.id, index: 0 })}
		/>
	);
}
